import { fieldPathSeparator } from "@hypertune/sdk/src/shared";

export default function stripRootPrefix(fieldPath: string): string {
  const rootPrefix = `root${fieldPathSeparator}`;
  return fieldPath.startsWith(rootPrefix)
    ? fieldPath.substring(rootPrefix.length)
    : fieldPath;
}
